/* eslint new-cap: ['error', { 'capIsNew': false }]*/
import { List, Map, fromJS } from 'immutable';

const clearDeal = (state) => state.clear();

const storeDeal = (state, data) => {
  let newState = state.clear();

  if (data.vesselLoadingPorts && data.vesselLoadingPorts.length > 0) {
    newState = newState.set('vesselLoadingPorts', fromJS(data.vesselLoadingPorts));
  } else {
    newState = newState.set('vesselLoadingPorts', List());
  }

  if (data.vesselDischargePorts && data.vesselDischargePorts.length > 0) {
    newState = newState.set('vesselDischargePorts', fromJS(data.vesselDischargePorts));
  } else {
    newState = newState.set('vesselDischargePorts', List());
  }

  return newState;
};

const newPort = (state, portType, initData) =>
  state.set(portType, state.get(portType, List()).push(initData ? new Map(initData) : new Map()));

const changePortData = (state, portType, idx, newPortData) =>
  state.set(portType, state.get(portType).set(idx, state.get(idx).merge(newPortData)));

const changePortField = (state, portType, idx, field, value) =>
  state.set(portType, state.get(portType).setIn([idx, field], value));

const changePortFields = (state, portType, idx, map = new Map()) =>
  state.mergeIn([portType, idx], map);

// eslint-disable-next-line
export const dealPortsReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'DEAL_LOADED':
    case 'UPDATE_DEAL_FROM_COPY':
      return storeDeal(state, action.data);
    case 'CLEAR_DEAL':
      return clearDeal(state);
    case 'NEW_PORT_ADDED':
      return newPort(state, action.portType, action.initData);
    case 'PORT_ALTERED':
      return changePortData(state, action.portType, action.idx, action.newPortData);
    case 'PORT_FIELD_ALTERED':
      return changePortField(state, action.portType, action.idx, action.field, action.value);
    case 'PORT_FIELDS_ALTERED':
      return changePortFields(state, action.portType, action.idx, action.map);
    default:
      return state;
  }
};
export const addNewPort = (dispatch, portType, initData) =>
  dispatch({ type: 'NEW_PORT_ADDED', portType, initData });

export const alterPort = (dispatch, portType, idx, newPortData) =>
  dispatch({ type: 'PORT_ALTERED', portType, idx, newPortData });

export const alterPortField = (dispatch, portType, idx, field, value) =>
  dispatch({ type: 'PORT_FIELD_ALTERED', portType, idx, field, value });

export const alterPortFields = (dispatch, portType, idx, map) =>
  dispatch({ type: 'PORT_FIELDS_ALTERED', portType, idx, map });
